import { render } from "./Spinner.vue?vue&type=template&id=653f3fb8&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=653f3fb8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653f3fb8"],['__file',"src/components/layout/Spinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "653f3fb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('653f3fb8', __exports__)) {
    api.reload('653f3fb8', __exports__)
  }
  
  module.hot.accept("./Spinner.vue?vue&type=template&id=653f3fb8&scoped=true", () => {
    api.rerender('653f3fb8', render)
  })

}


export default __exports__